import { Typography } from '@riac/design-system';
import { Modal } from '@riac/design-system';
import React, { startTransition, useEffect, useState } from 'react';
import { BirthdayVerifier } from './BirthdayVerifier';
import { OverlayContainer } from '@react-aria/overlays';

export type AgeVerificationCheckProps = React.PropsWithChildren<{}>;
export const AgeVerificationCheck = (props: AgeVerificationCheckProps): JSX.Element => {
  const [isVerified, setIsVerified] = useState<boolean>(true);

  useEffect(() => {
    if(window.localStorage.getItem('ageVerified') != 'true') {
      startTransition(() => setIsVerified(false));
    }
  }, []);
  if(isVerified) return null;

  return (
    <>
      <OverlayContainer>
        <Modal
          isOpen={!isVerified}
          title='Age Verification'
          type={'narrower'}
          footerButtons={
            <BirthdayVerifier
              onValidDate={() => {
                window.localStorage.setItem('ageVerified', 'true');
                setIsVerified(true);
              }}
              onInvalidDate={() => {
                window.location.href = 'https://www.google.com';
              }}
            />
          }
        >
          <div className='flex flex-col gap-3'>
            <Typography>
              Welcome to Rock Island Auction,
            </Typography>
            <Typography>
              This website contains content intended for individuals who are 18 years of age or older.
              By entering this website, you affirm that you understand and comply with the age restrictions in place.
              If you are not of legal age to access such content, we kindly request that you exit the site immediately.
              Thank you for respecting our guidelines and policies.
            </Typography>
            <Typography>
              <Typography>
                Best regards,
              </Typography>
              <Typography>
                Rock Island Auction Company
              </Typography>
            </Typography>
          </div>
        </Modal>
      </OverlayContainer>
      {props.children}
    </>
  );
};
